'use client';

import { useSpmTerminalKind } from './spm-dom';
import { resolveSpmTerminalKind, type SpmTerminalKind } from './terminal';
import type { SpmPageCodes } from './types';
import { PRODUCT_DETAIL_APP_SPM_CODES } from './codes/product-detail-app';
import { PRODUCT_DETAIL_PC_SPM_CODES } from './codes/product-detail-pc';
import { PRODUCT_DETAIL_WAP_SPM_CODES } from './codes/product-detail-wap';

/** 商详页 SPM 编码表：PC 与 WAP/App 内嵌是不同页面终端（B 位）编码，禁止混用。 */
const PRODUCT_DETAIL_SPM_CODES_BY_PLATFORM = {
  web: PRODUCT_DETAIL_PC_SPM_CODES,
  wap: PRODUCT_DETAIL_WAP_SPM_CODES,
  app: PRODUCT_DETAIL_APP_SPM_CODES,
} as const;

/**
 * 按终端选商详 SPM 编码表：与点击上报（spmPageCodesRef）同源同判断——
 * isWeb 取 PC 表；否则 App 内嵌取 app 派生表，其余取 WAP 表。
 * 供 JSX DOM 打标（useSpmDomAttr）与 hook 回调共用，保证 DOM 标记与上报编码同值。
 */
const pickProductDetailSpmCodes = (
  isWeb: boolean,
  spmTerminalKind: SpmTerminalKind,
): SpmPageCodes =>
  PRODUCT_DETAIL_SPM_CODES_BY_PLATFORM[isWeb ? 'web' : spmTerminalKind === 'app' ? 'app' : 'wap'];

/**
 * 事件回调/非 hook 场景取商详编码表：App 内嵌按客户端 UA 兜底（事件在客户端触发，
 * UA 可靠）。渲染期打标请用 useProductDetailSpmCodes（SSR 与客户端同值）。
 */
export const resolveProductDetailSpmCodes = (isWeb: boolean): SpmPageCodes =>
  pickProductDetailSpmCodes(isWeb, resolveSpmTerminalKind());

/** 渲染期取商详编码表：App 内嵌判定走 Provider 下发的服务端终端段。 */
export const useProductDetailSpmCodes = (isWeb: boolean): SpmPageCodes =>
  pickProductDetailSpmCodes(isWeb, useSpmTerminalKind());
